import script from "./SizesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SizesPanel.vue?vue&type=script&setup=true&lang=js"

import "./SizesPanel.vue?vue&type=style&index=0&id=5326d9b5&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5326d9b5"]])

export default __exports__